import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getSelectedHashtagId } from "selectors/hashtagFeedSelectors";
import moment from "moment";

const HashtagRow = ({ hashtag, onClick }) => {
  const selectedHashtagId = useSelector(getSelectedHashtagId);
  return (
    <div
      className={
        `${
          selectedHashtagId === hashtag.hashtag_id
            ? "text-purple-400 bg-purple-100"
            : ""
        }` +
        ` hover:bg-purple-400 hover:text-white pr-4 cursor-pointer pl-6 flex items-center relative`
      }
      onClick={onClick}
    >
      <div className="w-3/4 break-words">#{hashtag.name}</div>
      <div className="flex-grow text-right p-2 text-gray-400 w-1/4">
        {/*OK so momentjs doesn't let you format the output of to() so I'm sorry*/}
        {hashtag.search_date &&
          moment()
            .to(moment(hashtag.search_date).add(7, "days"), true)
            .replace("a ", "1")
            .replace("minutes", "min")
            .replace("minute", "min")
            .replace("days", "d")
            .replace("day", "d")
            .replace("months", "mo")
            .replace("month", "mo")
            .replace(" ", "")}
        {!hashtag.search_date && "Unknown"}
      </div>
    </div>
  );
};

HashtagRow.propTypes = {
  hashtag: PropTypes.object,
  onClick: PropTypes.func,
};

export default HashtagRow;
